import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    margin: theme.spacing(14, 0, 6, 0),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(10, 0, 2, 0),
    },
  },
  shopProductsHeading: {
    letterSpacing: '0.14px',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    maxWidth: 678,
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(6.25),
    },
  },
  searchWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100vw',
    maxWidth: '509px',
  },
  searchLabel: {
    display: 'flex',
    alignItems: 'flex-start',
    fontSize: theme.spacing(3.5),
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '20px',
    marginBottom: theme.spacing(1 / 2),
  },
  TextField: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
    border: 'none',
    boxShadow: `inset 0 0 0 1px ${theme.palette.grey['500']}`,
    transition: 'all .3s',
    boxSizing: 'border-box',
    fontSize: theme.typography.pxToRem(16),
    padding: theme.spacing(2, 2, 2, 4),
    lineHeight: '40px',
    height: 40,
    width: '100%',
    '&:hover:not($disabled)': {
      boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`,
    },

    '&$error': {
      boxShadow: `inset 0 0 0 2px ${theme.palette.error.main}`,
      '&:hover': { boxShadow: `inset 0 0 0 2px ${theme.palette.error.main}` },
      '&:focus': { boxShadow: `inset 0 0 0 2px ${theme.palette.error.main}` },
    },
  },
  searchButton: {
    whiteSpace: 'nowrap',
    height: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2, 6),
    lineHeight: '24px',
    minWidth: '144px',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      minWidth: '52px',
      height: '40px',
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(2, 6),
      lineHeight: '24px',
    },
  },
  searchTermText: {
    marginBottom: `${theme.spacing(2)}px !important`,
    letterSpacing: '0.09px',
  },
}))

interface DiscoPromoSearchFieldProps {
  handleDiscoItemSearch: (searchTerm: string) => void
  searchTerm: string
}

const DiscoPromoSearchField: React.FC<DiscoPromoSearchFieldProps> = ({
  handleDiscoItemSearch,
  searchTerm,
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const [term, setTerm] = useState('')
  const [searchTermText, setSearchTermText] = useState<string>(searchTerm)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const handleChange = (event) => setTerm(event.target.value)
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleDiscoItemSearch(term)
      setSearchTermText(term)
    }
  }
  const handlesearch = () => {
    handleDiscoItemSearch(term)
    setSearchTermText(term)
    setTerm('')
  }

  return (
    <Box className={classes.container}>
      <Typography component="h2" className={classes.shopProductsHeading}>
        <FormattedMessage id="SHOP_PRODUCTS" defaultMessage="Shop Products" />
      </Typography>
      <Typography component="span" className={classes.searchLabel}>
        <FormattedMessage
          id="SEARCH_PRODUCTS_LABEL"
          defaultMessage="Search Products"
        />
      </Typography>

      <Box className={classes.searchContainer}>
        <Box className={classes.searchWrapper}>
          <input
            id="disco-search-input"
            name="searchTerm"
            placeholder={formatMessage({
              id: 'DISCO_SEARCH_PLACEHOLDER',
              defaultMessage:
                'Search by Product Name, Product Number or Description',
            })}
            value={term}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            className={classes.TextField}
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          onClick={handlesearch}
          className={classes.searchButton}
        >
          {isMobile ? (
            <SearchIcon />
          ) : (
            <FormattedMessage id="SEARCH" defaultMessage="Search" />
          )}
        </Button>
      </Box>
      <Box>
        <Typography
          component="h3"
          className={classes.searchTermText}
          dangerouslySetInnerHTML={{ __html: searchTermText }}
        />
      </Box>
    </Box>
  )
}

export default DiscoPromoSearchField
